import styled from "@emotion/styled";

export const StyledConfigItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 52px;
  align-items: center;
  height: 48px;
  padding: 0rem 1rem;
`;
